const encodeQueryParams = require('../encodeQueryParams');
const { v4: uuid } = require('uuid');
const downloadFile = require('../downloadFile');
const { getAxiosInstance } = require('../connection');

module.exports = {
    url(eventId, uuid, { xlsx = false } = {}) {
        let url = [].join('/'),
            params = {};

        if (xlsx) {
            params.format = 'xlsx';
        }

        return '/' + ['events', eventId, 'leads', uuid ?? false].filter(Boolean).join('/') + encodeQueryParams(params);
    },
    downloadFile: function (eventId, eventName = '') {
        const ts = new Date()
            .toISOString() // e.g. "2025-09-16T14:23:45.678Z"
            .slice(0, 19) // keep up to seconds
            .replace(/[-:]/g, '') // remove separators
            .replace('T', '-');

        return downloadFile(this.url(eventId, false, { xlsx: true }), {
            filename: `event-leads-${(eventName ?? eventId.toString()).replace(/\W/g, '-').toLowerCase()}-${ts}.xlsx`,
        });
    },
    get: function (eventId) {
        return getAxiosInstance({
            url: this.url(eventId),
            method: 'get',
            json: true,
        }).then((response) => response.data);
    },
    create: function (eventId, sponsorId, code) {
        return getAxiosInstance({
            url: this.url(eventId),
            method: 'post',
            json: true,
            data: {
                qr_code: code,
                scan_uuid: uuid(),
                sponsor_id: sponsorId,
            },
        }).then((response) => response.data);
    },
    update: function (eventId, uuid, { note, priority, timeframe } = {}) {
        return getAxiosInstance({
            url: this.url(eventId, uuid),
            method: 'put',
            json: true,
            data: {
                scan_uuid: uuid,
                note,
                priority,
                timeframe,
            },
        }).then((response) => response.data);
    },
};
